/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DebitorennummerInputs */

const de__field_debitorennummer = /** @type {(inputs: _Field_DebitorennummerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debitorennummer`)
};

/**

* @param {_Field_DebitorennummerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_debitorennummer = /** @type {((inputs?: _Field_DebitorennummerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DebitorennummerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_debitorennummer(inputs)
});